import { useQuery, useMutation } from '@tanstack/react-query'

import {
  getPublicFormSchema,
  submitPublicForm,
  type PublicSubmitRequest,
} from '@/services/api/public-form.service'

export function usePublicFormSchema(token: string) {
  return useQuery({
    queryKey: ['public-form', token],
    queryFn: () => getPublicFormSchema(token),
    enabled: !!token,
    retry: false,
    staleTime: 60 * 1000,
  })
}

export function useSubmitPublicForm(token: string) {
  return useMutation({
    mutationFn: (data: PublicSubmitRequest) => submitPublicForm(token, data),
  })
}
